import { render } from "./StorageBlockedNotice.vue?vue&type=template&id=13613d6c&scoped=true"
import script from "./StorageBlockedNotice.vue?vue&type=script&lang=js"
export * from "./StorageBlockedNotice.vue?vue&type=script&lang=js"

import "./StorageBlockedNotice.vue?vue&type=style&index=0&id=13613d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13613d6c"]])

export default __exports__